import { createSlice } from "@reduxjs/toolkit";

const initialAddGameState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  appEventList: [],
  newGame: {},
  gameForEdit: {},
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const AppEventsSlice = createSlice({
  name: "appEventsSlice",
  initialState: initialAddGameState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    appEventListPaginated: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      console.log("state.entities",state.entities)
      console.log("state.listLoading",state.listLoading)
      console.log("state.totalCount",state.totalCount)
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.featureImage = {};
      state.bannerImage = {};
      state.inGameNameImage = {};
      state.tournamentImage = {};
    },

    AppEventList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.appEventList = countryList;
    },

    createGame: (state, action) => {
      const { newGame } = action.payload;
      state.error = null;
      state.newGame = newGame;
    },
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.gameForEdit = action.payload.gameForEdit;
      state.error = null;
    },
  },
});
